import { YleApiCredentials } from '../../common/types';

export const getClientYleApiCredentials = (): YleApiCredentials => {
  const authKeys: YleApiCredentials = {
    id: window.yleLeanback.clientYleApiCredentials.id,
    key: window.yleLeanback.clientYleApiCredentials.key,
  };
  if (!authKeys) {
    throw new Error(
      `No client YleApiCredentials found from window.yleLeanback`
    );
  }
  return authKeys;
};
